import React from 'react'
import { TableContextMenu } from "./TableContextMenu"
import { FormatNumberMXN } from "../common/Utils";
const showTotalservices = (row) => {
    let services = '';
    row.lstServices.forEach((service, index) => {
        if(index === 3)
            services += '... \n';
        services += service + '\n';
    });
    return (
        <span title={services}>
            {row.services}
        </span>
    );
};
export const ColumnsOrderList = (t, branchOfficeId, baseFilter) => {
    const columns = [
        {
            cell: row => <TableContextMenu
                            baseFilter={baseFilter} 
                            branchOfficeId={branchOfficeId} 
                            row={row} 
                        />,
            allowOverflow: true,
            button: true,
            width: '56px',
        }, 
        {
            name: t('TableOrder.order'),
            columnheader: {textAlign: 'center'},
            selector: 'PymtOrdId',
            sortable: true,
            center: true,
            width: "70px",
            cell: row => row.pymtOrdId
        },
        baseFilter === 'AdvanceOrder' && {
            name: t('TableOrder.relatedAdvance'),
            columnheader: {textAlign: 'center'},
            selector: 'AdvancePymtRequestId',
            sortable: true,
            center: true,
            width: "90px",
            cell: row => row.advancePymtRequestId
        },
        {
            name: t('TableOrder.service'),
            selector: 'Services',
            sortable: false,
            cell: row => showTotalservices(row)
        },
        {
            name: t('TableOrder.totalServices'),
            selector: 'TotalServices',
            sortable: false,
            center: true,
            width: "120px", 
            cell: row => row.totalServices
        },
        {
            name: t('TableOrder.status'),
            selector: 'StateDescription',
            sortable: false,
            width: "150px",            
            cell: row => row.stateDescription
        },{
            name: t('TableOrder.date'),
            selector: 'PymtOrdCreationDt',
            sortable: true,
            center: true,
            width: "150px",            
            cell: row => row.pymtOrdCreationDtStr
        },{
            name: t('TableOrder.vat'),
            selector: 'AmountOrder',
            sortable: false,
            right: true,
            width: "150px",            
            cell: row => FormatNumberMXN(row.amountOrder)
        }      
    ];
    return columns.filter(Boolean);
}

export const FiltersHeaders = (t) => (
    [
        {
            name: t('FilterHeaders.Orders'),
        },{
            name: t('FilterHeaders.Filters'),
        },{
            name: t('FilterHeaders.OrderList'),
        },
        {
            name: t('FilterHeaders.ReportGeneration'),
        },
        {
            name: t('FilterHeaders.Search'),
        },
        {
            name: t('FilterHeaders.OrderDateRange'),
        },{
            name: t('FilterHeaders.StartDate'),
        },{
            name: t('FilterHeaders.EndDate'),
        }  ,{
            name: t('FilterHeaders.Status'),
        }  ,{
            name: t('FilterHeaders.Service'),
        }  ,{
            name: t('FilterHeaders.VIN'),
        }      
    ]
)

  